import { useEffect, useRef, useState } from 'react';

const useCountdown = (defaultNumber = 60) => {
  const [number, setNumber] = useState(defaultNumber);
  const _timeout: any = useRef(null);

  const reduceNum = () => {
    _timeout.current = setTimeout(() => {
      setNumber((prev) => {
        if (prev > 0) {
          reduceNum();
          return prev - 1;
        }
        clearTimeout(_timeout.current);
        return defaultNumber;
      });
    }, 1000);
  };

  const setCountdown = (n = 60) => {
    if (_timeout.current) clearTimeout(_timeout.current);
    setNumber(n);
    reduceNum();
  };

  useEffect(() => () => {
    if (_timeout.current) clearTimeout(_timeout.current);
  }, []);

  return {
    countTime: number,
    setCountdown
  };
};

export default useCountdown;
